import { workloadAdjustmentError } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (request) =>
    present(
      repository
        .adjustWorkload(request)
        .then((period) => ({ request, period }))
        .catch((error) =>
          Promise.reject({
            request,
            error: {
              ...workloadAdjustmentError,
              forbidden: error?.status === 403,
              notFound: error?.status === 404,
            },
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
